module.exports = __webpack_public_path__ + "static/media/bankgirot-logo.91d6b021.png";